import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadPhonesInfoBlockData from '../../../Models/Content/AbroadPhonesInfoBlockData';
import AbroadPhonesInfoBlock from './AbroadPhonesInfoBlock';

export default class PopupBenefitBlock extends EpiComponent<AbroadPhonesInfoBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <AbroadPhonesInfoBlock context={this.getContext()} iContent={this.props.data} />;
  }
}
